export const PER_PAGE_PROPERTY = 'PER_PAGE_PROPERTY'
export const PAGE_PROPERTY = 'PAGE_PROPERTY'
export const PAGES_PROPERTY = 'PAGES_PROPERTY'
export const SEARCH_PROPERTY = 'SEARCH_PROPERTY'
export const REALSTATE_PROPERTY = 'REALSTATE_PROPERTY'
export const STATUS_COMMERCIAL_PROPERTY = 'STATUS_COMMERCIAL_PROPERTY'
export const ARRAY_LIST_PROPERTY = 'ARRAY_LIST_PROPERTY'
export const REFRESH_TABLE_PROPERTY = 'REFRESH_TABLE_PROPERTY'
